import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const quickLinks = [
  { label: '全部漫画', to: '/comics' },
  { label: '热门排行', to: '/comics?sort=hot' },
  { label: '新上架作品', to: '/comics?sort=new' },
  { label: '完结作品库', to: '/comics?sort=completed' },
  { label: '关于我们', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-article-line text-lg"></i>
              </span>
              <span className="font-display text-xl text-primary-600">4399漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一站式漫画阅读门户，汇集热门、新作与完结漫画，分类浏览、热门排行、站内搜索，助你高效追漫。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">漫画分类</h4>
            <ul className="grid grid-cols-2 gap-x-3 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.name}>
                  <Link
                    to={`/comics?category=${encodeURIComponent(c.name)}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-secondary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-500"></i>
                <a href="mailto:contact@manga4399.site" className="hover:text-primary-600">contact@manga4399.site</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-secondary-500"></i>
                <span>4399漫画网</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 4399漫画网 保留所有权利 · 本站所有漫画资源仅供学习交流</p>
          <div className="flex items-center gap-3">
            <a href="#" className="text-foreground-500 hover:text-primary-600" aria-label="微信" rel="nofollow"><i className="ri-wechat-line text-lg"></i></a>
            <a href="#" className="text-foreground-500 hover:text-primary-600" aria-label="微博" rel="nofollow"><i className="ri-weibo-line text-lg"></i></a>
            <a href="#" className="text-foreground-500 hover:text-primary-600" aria-label="QQ空间" rel="nofollow"><i className="ri-qq-line text-lg"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}